import React from 'react'
import ToolbarMenuItem from './toolbar-menu-item'

const ToolbarMenu = ({items}) => {
    return (
        <div className="toolbar__menu">
            {items.map((item, index) => {
                return (
                    <ToolbarMenuItem
                        key={`toolbar-menu-item-${index}`}
                        {...item}
                    />
                )
            })}
        </div>
    )
}

export default ToolbarMenu
